export default __webpack_public_path__ + "static/media/ic_dollar.47e4dc11.svg";